import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../../components/Common/PageTitle/index";
import MainPage from "./MainPage";
import LessonDashboard from "./LessonDashboard";
import CreateLessons from "./CreateLessons";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";
import { getAllLessons } from "../../../redux/actions/lessons.dispatcher";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  BREADCRUMB_LABEL,
  FOOTER_TEXT,
} from "./ACIM.constants";
import {
  RootBox,
  DisclaimerStack,
  DisclaimerText,
  StyledInfoIcon,
} from "./ACIM.styles";

const ACIM = () => {
  const dispatch = useDispatch();
  const { acimTab, setacimTab } = useQuickLinksItems();
  const { lessons } = useSelector((state) => state.lessons);

  useEffect(() => {
    dispatch(getAllLessons());
  }, [dispatch]);

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        breadCrumb={acimTab !== "main" && BREADCRUMB_LABEL}
        breadCrumbOnClick={() => setacimTab("main")}
        noIcon
        back={acimTab !== "main"}
        onBackClick={() => setacimTab("main")}
        videoUrl={VIDEO_URL}
      />

      {acimTab === "main" ? (
        <MainPage setCompState={setacimTab} />
      ) : acimTab === "lessons" ? (
        <LessonDashboard lessonsData={lessons} setCompState={setacimTab} />
      ) : (
        <CreateLessons />
      )}

      <DisclaimerStack direction="row" spacing={2}>
        <StyledInfoIcon />
        <DisclaimerText>{FOOTER_TEXT}</DisclaimerText>
      </DisclaimerStack>
    </RootBox>
  );
};

export default ACIM;
